import React from 'react';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: '50 Preguntas de Entrevista + Respuestas Modelo',
    description: 'Llegá preparado/a a cualquier entrevista con respuestas claras y seguras.'
  }, {
    title: 'Test: ¿Qué área de RRHH es para vos?',
    description: 'Descubrí en qué sector podés desarrollarte mejor según tu perfil.'
  }, {
    title: 'Pack de Mensajes para LinkedIn y Recruiters',
    description: 'Textos listos para copiar, adaptar y empezar a generar oportunidades.'
  }];
  return <section className="py-12 md:py-16 bg-white" data-id="element-21">
      <div className="max-w-6xl mx-auto px-4" data-id="element-22">
        <div className="text-center mb-8" data-id="element-23">
          <div className="inline-block bg-amber-500 text-white font-bold px-6 py-3 rounded-full text-lg mb-6 shadow-lg" data-id="element-24">
            🎁 GRATIS POR EL DÍA DE HOY 🎁
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-25">
            ACCEDÉS HOY TAMBIÉN A ESTOS BONUS
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-26">
          {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-br from-amber-50 to-white border-2 border-amber-500 rounded-xl p-6 hover:shadow-xl transition-all" data-id="element-27">
              <div className="flex items-center gap-3 mb-4" data-id="element-28">
                <GiftIcon className="w-8 h-8 text-amber-500" data-id="element-29" />
                <span className="text-2xl" data-id="element-30">🎁</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-3 text-lg" data-id="element-31">
                {bonus.title}
              </h3>
              <p className="text-sm text-gray-700" data-id="element-32">{bonus.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}